// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__+Zs5V","col":"ProductsDashboard_col__z35nS","card":"ProductsDashboard_card__fBVsD"};